import { useNavigate } from "react-router-dom";
import logo from "../assets/yeha-card.png"; // Promo image for the landing page
import PromoImage from "../assets/yeh.png"; // Promo image for the landing page
import { useEffect, useState, useRef } from "react";

export const VirtualCardLanding = () => {
  const navigate = useNavigate();
  const [isPC, setIsPC] = useState(false);
  const [tabToggle, setTabToggle] = useState("transaction"); // Default tab is "transaction"
  const [startX, setStartX] = useState(0); // Starting point of swipe
  const [currentX, setCurrentX] = useState(0); // Current swipe position
  const [dragging, setDragging] = useState(false); // Whether swipe is ongoing
  const sliderRef = useRef(null); // Slider reference for transformations
  const sliderContainerRef = useRef(null); // To contain the swipe area

  useEffect(() => {
    const checkDeviceType = () => {
      if (window.innerWidth > 600) {
        setIsPC(true); // If it's a PC
      } else {
        setIsPC(false); // Otherwise, it's mobile/tablet
      }
    };

    checkDeviceType(); // Initial device check
    window.addEventListener("resize", checkDeviceType); // Handle resize
    return () => {
      window.removeEventListener("resize", checkDeviceType); // Clean up
    };
  }, []);

  // Handle swipe start (touch begin)
  const handleTouchStart = (e) => {
    if (sliderContainerRef.current) {
      setDragging(true); // Set dragging state to true
      setStartX(e.touches[0].clientX); // Get the touch start position
    }
  };

  // Handle touch movement (update swipe position)
  const handleTouchMove = (e) => {
    if (!dragging) return;

    const moveX = e.touches[0].clientX; // Get the current touch position
    const deltaX = moveX - startX; // Calculate movement delta in X direction

    const containerWidth = sliderContainerRef.current.clientWidth;
    const sliderWidth = sliderRef.current.clientWidth; // Width of the sliding element

    // Limit movement based on container width (prevent going beyond boundaries)
    const minX = 0; // Minimum x-position (start point)
    const maxX = containerWidth - sliderWidth; // Maximum x-position (end point)

    // Adjust the maxX to make the slider move -1.5px beyond the right edge
    const maxXAdjusted = maxX - 5; // Adjusted maximum position after considering the -1.5px

    const constrainedX = Math.max(minX, Math.min(deltaX, maxXAdjusted)); // Constrain the X position

    if (sliderRef.current) {
      sliderRef.current.style.transition = 'none'; // Disable transition during drag for smoothness
      sliderRef.current.style.transform = `translateX(${constrainedX}px)`; // Apply constrained drag translation
    }
    setCurrentX(constrainedX); // Store current swipe distance
  };

  // Handle touch end (finalize swipe)
  const handleTouchEnd = () => {
    if (!dragging) return;
    setDragging(false); // Reset dragging state

    const containerWidth = sliderContainerRef.current.clientWidth;
    const sliderWidth = sliderRef.current.clientWidth;

    const edgeBeforeRadiusThreshold = containerWidth - sliderWidth - 50; // 50px from the edge

    if (currentX >= edgeBeforeRadiusThreshold) {
      navigate("/login"); // Navigate only if near the edge
    }

    if (currentX > containerWidth / 2) {
      setTabToggle("recharge"); // If swipe moved more than half the container width, change to "recharge"
    } else {
      setTabToggle("transaction"); // Otherwise, stay on "transaction"
    }

    if (sliderRef.current) {
      sliderRef.current.style.transition = 'transform 0.3s ease'; // Enable smooth transition back
      sliderRef.current.style.transform = `translateX(${tabToggle === "recharge" ? containerWidth - sliderWidth : 0}px)`; // Apply smooth transition based on tab change
    }

    setCurrentX(0); // Reset swipe distance state
  };

  const handleToggle = (tab) => {
    setTabToggle(tab); // Handle tab change (manual switch, apart from swipe)
  };

  // Handle the PC version Maintenance message
  if (isPC) {
    return (
      <div className="w-full h-screen flex items-center justify-center bg-[#11272a]">
        <div className="bg-yellow-100 text-black text-center py-4 px-6 text-xl sm:text-2xl font-medium">
          ⚠️ PC version is currently under maintenance. Please use a mobile device.
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-screen flex flex-col items-center justify-between bg-[#11272a]">
      {/* Logo in top-left corner */}
      <div className="absolute top-4 left-4">
        <img src={logo} alt="Ash Card" className="h-12" />
      </div>

      {/* Main Content */}
      <div className="w-[90%] md:w-[75%] flex flex-col items-center gap-4 text-center pt-24"> {/* Increased pt-32 for more space */}
        <div className="flex flex-col">
          <div className="text-center text-white font-semibold text-4xl">
            Manage Your Finances Easily
          </div>
          <p className="text-md sm:text-lg md:text-xl text-white">
            Get Virtual Cards for International Payment.
          </p>
        </div>

        {/* Promo Image as Landing Image */}
        <div className="w-full flex justify-center mt-4">
          <img
            src={PromoImage}
            alt="Virtual Cards"
            className="w-full max-w-md md:max-w-lg"
          />
        </div>
      </div>

      {/* Tab Switch (Transaction and Recharge) */}
      <div
        className="relative flex max-w-[340px] w-full h-12 bg-gray-200 rounded-full items-center p-5 absolute bottom-24"
        ref={sliderContainerRef}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Slider */}
        <div
          ref={sliderRef}
          className={`absolute top-0.6 left-[5px] h-[85%] w-[29%] bg-[#11272a] rounded-full flex items-center justify-center`}
        >
          <span className="text-white text-1xs font-medium">Get Start</span>
        </div>

        {/* Transaction Button */}
        <div
          onClick={() => handleToggle("transaction")}
          className={`flex-1 text-center text-sm font-medium ${
            tabToggle === "transaction" ? "text-white" : "text-gray-500"
          } cursor-pointer`}
        >
          {/* Transaction */}
        </div>

        {/* Recharge Button */}
        <div
          onClick={() => handleToggle("recharge")}
          className={`flex-1 text-center text-sm font-medium ${
            tabToggle === "recharge" ? "text-white" : "text-gray-500"
          } cursor-pointer`}
        >
          <span className="text-lg">
            <span className="mx-4" style={{ opacity: 0.2}}>{"Swipe"}</span>
            <span className="mx-4" style={{ opacity: 0.4}}>{">"}</span>
            <span className="mx-4" style={{ opacity: 0.7 }}>{">"}</span>
            <span className="mx-4" style={{ opacity: 1 }}>{">"}</span>
          </span>
        </div>
      </div>

      {/* Add the following meta tag to disable zoom in your HTML's <head> */}
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
    </div>
  );
};
